import React from 'react';
import { NavLink } from 'react-router-dom';

import MobileMenuLink from 'data/containers/mobileMenuLink';
import ProjectFilters from 'data/containers/projectFilters';

import './style.css';

const Header = props => {
    return (
        <div className="Header">
            <div className="Header__branding">
                <NavLink className="Branding" to="/">
                    <span className="Branding__name">Kurt Riddell.</span>
                    <span className="Branding__role">
                        Director of Photography.
                    </span>
                </NavLink>
            </div>
            <div className="Header__filters">
                <ProjectFilters />
            </div>
            <div className="Header__contact">
                <NavLink className="Contact" to="/profile">
                    <span className="Contact__text">
                        Kit<br /> + Contact
                    </span>
                </NavLink>
            </div>
            <div className="Header__menuLink">
                <MobileMenuLink />
            </div>
        </div>
    );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/organisms/app/header/index.js